import * as React from "react";
import Jumbotron from "../components/Jumbotron/Jumbotron";
import TeamMember from "../components/TeamMember/TeamMember";
import BioBox from "../components/BioBox/BioBox";
import Footer from "../components/Footer/Footer";

import landing from "../images/team-landing.jpg";
import smallpic from "../images/team-landing-sm.jpg";

import classes from "../Stylesheets/team.module.css";
import { PeopleEntity } from "../App";
import { useNavigate, useLocation } from "react-router-dom";

interface IProps {
  peopleEntities?: PeopleEntity[] | null | undefined;
}

interface LocationState {
  isBioOpen?: boolean;
  clickedPerson?: PeopleEntity;
}

const Team = (props: IProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const scrollAnchorRef = React.useRef<HTMLDivElement>(null);

  const locationState = (location.state as LocationState) || {};

  const clickedPersonHandler = (object: PeopleEntity) => {
    navigate(location.pathname, {
      state: { isBioOpen: true, clickedPerson: object },
    });
    if (scrollAnchorRef.current) {
      scrollAnchorRef.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  };

  const closeHandler = () => {
    navigate(location.pathname, { state: { isBioOpen: false } });
  };

  if (props.peopleEntities === undefined || props.peopleEntities === null) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      {locationState.isBioOpen && locationState.clickedPerson ? (
        <section className="parent">
          <Jumbotron image={landing} preimage={smallpic} title="Meet the Team" className={classes["jumbotron"]} />
          <section className={classes["mainText"]}>
            <h1>Working Together with Excellence</h1>
            <p>
              "Teamwork is the ability to work together toward a common vision. The ability to direct individual accomplishments toward
              organizational objectives. It is the fuel that allows common people to attain uncommon results." – Andrew Carnegie
            </p>
          </section>
          <div ref={scrollAnchorRef} className="parent">
            <BioBox
              name={locationState.clickedPerson.Name}
              position={locationState.clickedPerson.Title}
              bio={locationState.clickedPerson.Description}
              photo={locationState.clickedPerson.ImageZoom}
              clicked={() => closeHandler()}
            />
          </div>
          <section className={classes["wrapper"]}>
            {props.peopleEntities.map((member, index) => {
              return (
                <TeamMember
                  name={member.Name}
                  position={member.Title}
                  photo={member.ImageSprite}
                  clicked={() => clickedPersonHandler(member)}
                  key={index}
                />
              );
            })}
          </section>
          <Footer />
        </section>
      ) : (
        <section className="parent">
          <Jumbotron image={landing} preimage={smallpic} title="Meet the Team" className={classes["jumbotron"]} />
          <section className={classes["mainText"]}>
            <h1>Working Together with Excellence</h1>
            <p>
              "Teamwork is the ability to work together toward a common vision. The ability to direct individual accomplishments toward
              organizational objectives. It is the fuel that allows common people to attain uncommon results." – Andrew Carnegie
            </p>
          </section>
          <div ref={scrollAnchorRef} className="parent"></div>
          <section className={classes["wrapper"]}>
            {props.peopleEntities.map((member, index) => {
              return (
                <TeamMember
                  name={member.Name}
                  position={member.Title}
                  photo={member.ImageSprite}
                  clicked={() => clickedPersonHandler(member)}
                  key={index}
                />
              );
            })}
          </section>
          <Footer />
        </section>
      )}
    </React.Fragment>
  );
};

export default Team;
